enum RouteName {
  HOME = 'Home',
  LOGIN_FAILED = 'LoginFailed',
  SIMULATION = 'Simulation',
  INSTALLATIONS = 'Installations',
  SETTINGS = 'Settings',
  SETTINGS_COMPANY = 'SettingsCompany',
  SETTINGS_TEAM = 'SettingsTeam',
  SETTINGS_SUBCONTRACTING = 'SettingsSubcontracting',
  ERROR_NO_ACCESS = 'ErrorNoAccess',
}

export default RouteName;
